import memoize from 'lodash-es/memoize';
const requestFullscreen = (el) => {
    if (el.requestFullscreen)
        el.requestFullscreen();
    // @ts-ignore
    else if (el.webkitRequestFullscreen)
        el.webkitRequestFullscreen();
    // @ts-ignore
    else if (el.mozRequestFullScreen)
        el.mozRequestFullScreen();
    // @ts-ignore
    else if (el.msRequestFullscreen)
        el.msRequestFullscreen();
    // @ts-ignore
    else if (el.webkitEnterFullScreen)
        el.webkitEnterFullScreen();
};
const exitFullscreen = () => {
    if (document.exitFullscreen)
        document.exitFullscreen();
    // @ts-ignore
    else if (document.webkitExitFullscreen)
        document.webkitExitFullscreen();
    // @ts-ignore
    else if (document.mozCancelFullScreen)
        document.mozCancelFullScreen();
    // @ts-ignore
    else if (document.msExitFullscreen)
        document.msExitFullscreen();
};
const mouseEvent = (event) => {
    if (event.originalEvent)
        event = event.originalEvent;
    if (event && event.touches && event.touches.length > 0)
        return event.touches[0];
    else if (event && event.changedTouches && event.changedTouches.length)
        return event.changedTouches[0];
    return event;
};
const webp = memoize(() => {
    const elem = document.createElement('canvas');
    if (elem.getContext && elem.getContext('2d')) {
        // was able or not to get WebP representation
        return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    }
    // very old browser like IE 8, canvas not supported
    return false;
});
const getParent = (elem, selector) => {
    for (; elem && elem !== document; elem = elem.parentNode)
        if (elem.matches(selector))
            return elem;
};
const isParent = (elem, parent) => {
    for (; elem && elem !== document; elem = elem.parentNode)
        if (elem === parent)
            return true;
    return false;
};
const resetElement = (element) => {
    const clone = element.cloneNode(true);
    element.parentNode?.insertBefore(clone, element);
    element.parentNode?.removeChild(element);
    return clone;
};
const offsetTop = function (el) {
    let offset = el.offsetTop;
    if (el.offsetParent)
        offset += offsetTop(el.offsetParent);
    return offset;
};
const local = () => window && (parseInt(window.location.port) >= 8000);
const waitRepaint = (cb) => {
    const o = {};
    o.raf = window.requestAnimationFrame(() => {
        o.raf = window.requestAnimationFrame(cb);
    });
    return o;
};
export default {
    requestFullscreen,
    exitFullscreen,
    offsetTop,
    resetElement,
    mouseEvent,
    getParent,
    isParent,
    webp,
    local,
    waitRepaint
};
